import { render, staticRenderFns } from "./Preloading.vue?vue&type=template&id=bdfbb4fc&"
import script from "./Preloading.vue?vue&type=script&lang=js&"
export * from "./Preloading.vue?vue&type=script&lang=js&"
import style0 from "./Preloading.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports